import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Media } from '../../../../../theme/Media';
import { Button } from '../../../../Controls/Button';
import { useTableContext } from '../../context';
export const ActionButton = memo(forwardRef(function ActionButton({ children, ...props }, ref) {
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const { compact } = useTableContext();
    return (_jsx(Button, { ...props, iconOnly: !isMobile && !compact, ghost: true, ref: ref, children: children }));
}));
